
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'portals-platform-reference-fe',
  currentProjectVersion: 'static-1.901',
  depVersions: {
  "portals-platform-reference-fe": "static-1.901",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.455",
  "foundations-assets": "static-1.4737",
  "foundations-theming": "static-1.4304",
  "foundations-theming-base": "static-1.3289",
  "foundations-theming-specialty": "static-1.2020",
  "head-dlb": "static-1.4921",
  "hs-test-utils": "static-1.7903",
  "hub-http-shared-msw-handlers": "static-1.9709",
  "hubspot-dlb": "static-2.1828",
  "react-dlb": "static-1.76",
  "data-fetching-client": "static-1.9567",
  "enviro": "static-4.425",
  "foundations-components": "static-1.7703",
  "history": "static-4.47",
  "hub-http": "static-1.6110",
  "HubStyleTokens": "static-2.11341",
  "I18n": "static-7.1598",
  "js-cookie": "static-1.18",
  "PortalIdParser": "static-2.386",
  "portals-platform-lib": "static-1.688",
  "quartz-config": "static-1.633",
  "quartz-core": "static-1.6074",
  "quartz-routing": "static-1.285",
  "quick-fetch": "static-1.3826",
  "react": "static-7.184",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16546",
  "react-router-dom": "static-5.26",
  "rpc-client-utils": "static-1.4535",
  "ui-addon-react-router-dom": "static-1.9436",
  "UIComponents": "static-3.8288",
  "usage-tracker": "static-1.7228",
  "usage-tracker-anonymous": "static-1.5645",
  "usage-tracker-core": "static-1.7078",
  "apollo-stack-hubspot": "static-3.79",
  "hs-promise-rejection-tracking": "static-1.5473",
  "raven": "static-3.5808",
  "raven-hubspot": "static-1.6115",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4034",
  "immutable": "static-2.76",
  "metrics-js": "static-1.9522",
  "react-redux": "static-7.69",
  "redux": "static-4.16",
  "styled-components": "static-2.87",
  "bend-plugin-trellis-migration": "static-1.3317",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3132",
  "quartz-webpack": "static-1.3079",
  "webpack-env": "static-1.54",
  "bend-plugin-foundations-theming": "static-1.2787",
  "framer-motion": "static-1.70",
  "hs-story-utils": "static-1.9321",
  "react-utils": "static-2.5259",
  "StyleGuideUI": "static-3.485",
  "stylex": "static-1.30",
  "HeadJS": "static-2.732",
  "quartz": "static-1.6855",
  "hs-test-utils-bend-plugin": "static-1.3014",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "ts-schema": "static-1.3989",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.80",
  "bend-plugin-foundations-components": "static-1.3972",
  "floating-ui": "static-1.54",
  "react-aria": "static-1.64",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.97",
  "tanstack-table": "static-1.53",
  "trellis-assets": "static-1.1501",
  "ui-fonts": "static-1.603",
  "ui-images": "static-2.1124",
  "i18n-data": "static-1.218",
  "moment-timezone": "static-5.81",
  "usage-tracker-multi": "static-1.5642",
  "dispatcher": "static-1.134",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.816",
  "hubspotter-http": "static-1.4563",
  "icons": "static-2.637",
  "jasmine": "static-4.4216",
  "jasmine-runner": "static-1.6361",
  "mobile-manifest-mixins": "static-1.506",
  "module-federation": "static-1.21",
  "quartz-auth": "static-1.530",
  "quartz-head": "static-1.520",
  "quartz-i18n": "static-1.530",
  "quartz-test": "static-1.530",
  "quartz-tracking": "static-1.234",
  "usage-tracker-container": "static-1.7218",
  "csstype": "static-1.50",
  "chirp-fetch": "static-1.1773",
  "cssUtils": "static-1.764",
  "HubStyle": "static-2.11649",
  "bender-build-tools": "static-1.3057",
  "react-input-autosize": "static-2.17",
  "usage-tracker-public": "static-1.7039",
  "sassPrefix": "static-1.153",
  "hubspotter-http-shared-msw-handlers": "static-1.9707",
  "usage-tracker-session-replay": "static-1.4914",
  "amplitude-session-replay-browser": "static-1.58"
},
  depPathPrefixes: {
  "portals-platform-reference-fe": "/portals-platform-reference-fe/static-1.901",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.455",
  "foundations-assets": "/foundations-assets/static-1.4737",
  "foundations-theming": "/foundations-theming/static-1.4304",
  "foundations-theming-base": "/foundations-theming-base/static-1.3289",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2020",
  "head-dlb": "/head-dlb/static-1.4921",
  "hs-test-utils": "/hs-test-utils/static-1.7903",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9709",
  "hubspot-dlb": "/hubspot-dlb/static-2.1828",
  "react-dlb": "/react-dlb/static-1.76",
  "data-fetching-client": "/data-fetching-client/static-1.9567",
  "enviro": "/enviro/static-4.425",
  "foundations-components": "/foundations-components/static-1.7703",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.6110",
  "HubStyleTokens": "/HubStyleTokens/static-2.11341",
  "I18n": "/I18n/static-7.1598",
  "js-cookie": "/js-cookie/static-1.18",
  "PortalIdParser": "/PortalIdParser/static-2.386",
  "portals-platform-lib": "/portals-platform-lib/static-1.688",
  "quartz-config": "/quartz-config/static-1.633",
  "quartz-core": "/quartz-core/static-1.6074",
  "quartz-routing": "/quartz-routing/static-1.285",
  "quick-fetch": "/quick-fetch/static-1.3826",
  "react": "/react/static-7.184",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16546",
  "react-router-dom": "/react-router-dom/static-5.26",
  "rpc-client-utils": "/rpc-client-utils/static-1.4535",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9436",
  "UIComponents": "/UIComponents/static-3.8288",
  "usage-tracker": "/usage-tracker/static-1.7228",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5645",
  "usage-tracker-core": "/usage-tracker-core/static-1.7078",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5473",
  "raven": "/raven/static-3.5808",
  "raven-hubspot": "/raven-hubspot/static-1.6115",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4034",
  "immutable": "/immutable/static-2.76",
  "metrics-js": "/metrics-js/static-1.9522",
  "react-redux": "/react-redux/static-7.69",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.87",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3317",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3132",
  "quartz-webpack": "/quartz-webpack/static-1.3079",
  "webpack-env": "/webpack-env/static-1.54",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2787",
  "framer-motion": "/framer-motion/static-1.70",
  "hs-story-utils": "/hs-story-utils/static-1.9321",
  "react-utils": "/react-utils/static-2.5259",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "stylex": "/stylex/static-1.30",
  "HeadJS": "/HeadJS/static-2.732",
  "quartz": "/quartz/static-1.6855",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3014",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "ts-schema": "/ts-schema/static-1.3989",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.80",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3972",
  "floating-ui": "/floating-ui/static-1.54",
  "react-aria": "/react-aria/static-1.64",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.97",
  "tanstack-table": "/tanstack-table/static-1.53",
  "trellis-assets": "/trellis-assets/static-1.1501",
  "ui-fonts": "/ui-fonts/static-1.603",
  "ui-images": "/ui-images/static-2.1124",
  "i18n-data": "/i18n-data/static-1.218",
  "moment-timezone": "/moment-timezone/static-5.81",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5642",
  "dispatcher": "/dispatcher/static-1.134",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.816",
  "hubspotter-http": "/hubspotter-http/static-1.4563",
  "icons": "/icons/static-2.637",
  "jasmine": "/jasmine/static-4.4216",
  "jasmine-runner": "/jasmine-runner/static-1.6361",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.506",
  "module-federation": "/module-federation/static-1.21",
  "quartz-auth": "/quartz-auth/static-1.530",
  "quartz-head": "/quartz-head/static-1.520",
  "quartz-i18n": "/quartz-i18n/static-1.530",
  "quartz-test": "/quartz-test/static-1.530",
  "quartz-tracking": "/quartz-tracking/static-1.234",
  "usage-tracker-container": "/usage-tracker-container/static-1.7218",
  "csstype": "/csstype/static-1.50",
  "chirp-fetch": "/chirp-fetch/static-1.1773",
  "cssUtils": "/cssUtils/static-1.764",
  "HubStyle": "/HubStyle/static-2.11649",
  "bender-build-tools": "/bender-build-tools/static-1.3057",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "usage-tracker-public": "/usage-tracker-public/static-1.7039",
  "sassPrefix": "/sassPrefix/static-1.153",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9707",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4914",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58"
}
};
